import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/noimage.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-968919dc")

_pushScopeId("data-v-968919dc")
const _hoisted_1 = { class: "my-list-folder-list-item" }
const _hoisted_2 = { class: "my-list-folder-list-item-image-area" }
const _hoisted_3 = { class: "my-list-folder-list-item-image" }
const _hoisted_4 = {
  key: 1,
  class: "my-list-folder-list-item-image-noimage",
  src: _imports_0
}
const _hoisted_5 = { class: "my-list-folder-list-item-text-area" }
const _hoisted_6 = { class: "my-list-folder-list-item-text-name-view" }
const _hoisted_7 = { class: "my-list-folder-list-item-button-area" }
const _hoisted_8 = { class: "my-list-folder-list-item-button-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.imageUrl)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              class: "my-list-folder-list-item-image-icon",
              src: _ctx.imageUrl
            }, null, 8, ["src"]))
          : (_openBlock(), _createBlock("img", _hoisted_4))
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, _toDisplayString(_ctx.name), 1),
      _withDirectives(_createVNode("div", { class: "my-list-folder-list-item-text-number-view" }, _toDisplayString(_ctx.getNumber()), 513), [
        [_vShow, !_ctx.isAll]
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("button", {
          class: "my-list-folder-list-item-button-container-button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.checkAction(...args)))
        }, [
          _createVNode("img", {
            class: "my-list-folder-list-item-button-check-image",
            src: _ctx.checkedImage
          }, null, 8, ["src"])
        ])
      ])
    ])
  ]))
})